<template>
  <base-top-bar class="top-bar" with-badges @back="backHandler">
    <h1 slot="text">{{ $t("search.search-results") }}</h1>
    <button class="price-sort" aria-label="sort" @click="handlePriceSort">
      {{ $t("search.sort-by-price") }}
      <sort-icon class="price-sort__img" :alt="$t('search.sort-by-price')" />
    </button>
  </base-top-bar>
</template>

<script>
import BaseTopBar from "@/components/ui/BaseTopBar/BaseTopBar.vue";
import SortIcon from "@/assets/images/sort-price.svg";
import { SORT_BY_PRICE, RESET_PAGE } from "@/store/mutationTypes";
import { GET_DATA_FROM_API } from "@/store/actionTypes";

export default {
  name: "ResultsTopBar",
  components: {
    BaseTopBar,
    SortIcon
  },
  methods: {
    handlePriceSort() {
      this.$store.commit(RESET_PAGE);
      this.$store.commit(SORT_BY_PRICE);
      this.$store.dispatch(GET_DATA_FROM_API);
    },
    backHandler() {
      this.$route.name === "dealerResults"
        ? this.$router.push(`/dealer/${this.$route.params.dealerName}`)
        : this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.price-sort {
  display: flex;
  align-items: center;

  &__img {
    margin-left: 20px;
  }
}

@media screen and (min-width: $media-l) {
  .top-bar {
    padding: 25px 0 50px;
  }
}
</style>
